import React from 'react';

const OriginalVACharacter = ({ className }) => {
  return (
    <svg
      className={className || "w-full h-auto"}
      width="500"
      height="400"
      viewBox="0 0 500 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background Shape */}
      <ellipse cx="250" cy="260" rx="170" ry="140" fill="#e9f1ff" />
      
      {/* Character Body */}
      <path
        d="M230 300c0-38.66 31.34-70 70-70s70 31.34 70 70v40H230v-40z"
        fill="#243e85"
      />
      
      {/* Character Head */}
      <circle cx="300" cy="180" r="50" fill="#ffdfc8" />
      
      {/* Eyes */}
      <circle cx="280" cy="175" r="5" fill="#000" />
      <circle cx="320" cy="175" r="5" fill="#000" />
      
      {/* Smile */}
      <path
        d="M285 195c10 10 20 10 30 0"
        stroke="#000"
        strokeWidth="3"
        strokeLinecap="round"
      />
      
      {/* Arms */}
      <path
        d="M230 250l-40 40M370 250l40 40"
        stroke="#243e85"
        strokeWidth="20"
        strokeLinecap="round"
      />
      
      {/* Computer/Laptop */}
      <rect x="220" y="330" width="160" height="10" rx="2" fill="#333" />
      <rect x="240" y="280" width="120" height="70" rx="4" fill="#7AA5D7" />
      <rect x="250" y="290" width="100" height="50" rx="2" fill="#C4E0F9" />
      
      {/* Task Icons floating */}
      <circle cx="150" cy="150" r="25" fill="#f4a424" fillOpacity="0.8" className="animate-float" style={{ animationDelay: '0s' }} />
      <circle cx="190" cy="100" r="20" fill="#a5c8ff" fillOpacity="0.8" className="animate-float" style={{ animationDelay: '0.5s' }} />
      <circle cx="400" cy="120" r="22" fill="#f4a424" fillOpacity="0.8" className="animate-float" style={{ animationDelay: '1s' }} />
      <circle cx="450" cy="180" r="18" fill="#a5c8ff" fillOpacity="0.8" className="animate-float" style={{ animationDelay: '1.5s' }} />
      
      {/* Task Icon Symbols */}
      <path d="M150 150l-8-8 4-4 4 4 8-8 4 4-12 12z" fill="white" />
      <path d="M190 100h-10v-6h10v-4l8 7-8 7v-4z" fill="white" />
      <path d="M400 114v12h-12v-12h12z M394 118h-2v4h2v-4z M398 118h-2v4h2v-4z" fill="white" />
      <path d="M446 180h8v-8h-8z M446 180h8v2h-8z" fill="white" />
    </svg>
  );
};

export default OriginalVACharacter;